import { useMemo, useState } from "react";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import EmptyState from "@/components/base/EmptyState";
import Pagination from "@/components/base/Pagination";
import { useSeo } from "@/hooks/useSeo";
import { getByCategory, paginate, sortContent, type SortKey } from "@/lib/content";
import { getCategoryMeta } from "@/mocks/categories";
import CategoryHeader from "@/pages/category/components/CategoryHeader";
import SortTabs from "@/pages/category/components/SortTabs";
import NewsListCard from "@/pages/category/components/NewsListCard";

const meta = getCategoryMeta("film-news")!;
const PAGE_SIZE = 6;

const sortOptions = [
  { key: "date-desc", label: "最新发布" },
  { key: "date-asc", label: "最早发布" },
  { key: "heat-desc", label: "热度最高" },
];

export default function FilmNewsPage() {
  const [sort, setSort] = useState<SortKey>("date-desc");
  const [page, setPage] = useState(1);

  useSeo({
    title: "影视资讯 - 红桃网",
    description:
      "红桃网影视资讯频道，聚焦国内外影视行业前沿动态，涵盖开机杀青、定档上映、票房数据、幕后制作与产业观察。",
    keywords: "影视资讯,影视动态,电影新闻,红桃网",
  });

  const result = useMemo(() => {
    const list = sortContent(getByCategory("film-news"), sort);
    return paginate(list, page, PAGE_SIZE);
  }, [sort, page]);

  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <Navbar />
      <main className="flex-1 w-full">
        <CategoryHeader meta={meta} />
        <div className="w-full px-4 md:px-8 py-6 md:py-8">
          <div className="flex items-center justify-between flex-wrap gap-3 mb-6">
            <SortTabs
              options={sortOptions}
              value={sort}
              onChange={(k) => {
                setSort(k as SortKey);
                setPage(1);
              }}
            />
            <span className="text-sm text-foreground-500">
              共 {result.total} 条资讯
            </span>
          </div>

          {result.items.length === 0 ? (
            <EmptyState message="暂无相关影视资讯，您可以尝试调整筛选条件。" />
          ) : (
            <div className="space-y-4">
              {result.items.map((item) => (
                <NewsListCard key={item.id} item={item} categoryLabel="影视资讯" />
              ))}
            </div>
          )}

          <Pagination page={result.page} totalPages={result.totalPages} onChange={setPage} />
        </div>
      </main>
      <Footer />
    </div>
  );
}